import { createContext, useContext, type RefObject } from "react";
import type { SlateEditorHandle } from "@components/mainInterface/chat/slate/SlateEditor";
import type { DraftRefsTarget } from "../useDraftRefsByTarget";

interface ChatDragContextValue {
    composerRefs: Record<DraftRefsTarget, RefObject<SlateEditorHandle | null>>;
}

export const ChatDragContext = createContext<ChatDragContextValue | null>(null);

/** The composer the current drag would drop into; kept apart so hover changes only re-render composers. */
export const ChatDropTargetContext = createContext<DraftRefsTarget | null>(
    null,
);

/** True inside `TaskChatDndProvider`, where rows can be dragged into the chat. */
export function useChatDragAvailable(): boolean {
    return useContext(ChatDragContext) !== null;
}
